import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'app/services/client-service';
import { CommonsText } from 'app/commons/CommonsText';
import { CommonsUtils } from 'app/commons/CommonsUtils';
import { AccessDataDTO } from 'app/header-footer-template/model/AccessDataDTO';

@Component({
  selector: 'app-profile-password',
  templateUrl: './profile-password.component.html',
  styleUrls: ['./profile-password.component.scss']
})
export class ProfilePasswordComponent {

    @Output() saved = new EventEmitter<void>();

    form: FormGroup;
    show = { actual: false, new: false, confirmation: false };
    submitted = false;
    running = false;
    messages: string[] = [];

    constructor(private fb: FormBuilder,
                private clientService: ClientService,
                private toastr: ToastrService) {
        this.form = this.fb.group({
            actual: ['', [Validators.required, Validators.pattern(CommonsUtils.PASSWORD_REGEX)]],
            new: ['', [Validators.required, Validators.pattern(CommonsUtils.PASSWORD_REGEX)]],
            confirmation: ['', [Validators.required, Validators.pattern(CommonsUtils.PASSWORD_REGEX), CommonsUtils.matchValues('new')]]
        });

        this.form.valueChanges.subscribe(() => {
            this.messages = [];
        });
    }

    toggle(field: 'actual' | 'new' | 'confirmation'): void {
        this.show[field] = !this.show[field];
    }

    isInvalid(name: string): boolean {
        const c = this.form.get(name);
        return c && c.invalid && (c.dirty || c.touched || this.submitted);
    }

    save(): void {
        this.submitted = true;
        this.messages = [];
        if (this.form.invalid || this.running) { return; }

        this.running = true;
        const dto: AccessDataDTO = this.form.value;
        this.clientService.onModifyAccess(dto)
            .then(() => {
                this.running = false;
                this.toastr.success(CommonsText.DATOS_ACCESO_ACTUALIZADOS_EXITO,
                    CommonsText.OPERACION_COMPLETADA, { timeOut: 5000 });
                this.form.reset();
                this.submitted = false;
                this.saved.emit(); //ISAAc revisar, creo que no es necesario
            })
            .catch(error => {
                this.running = false;
                const resp = error && error.error && error.error.response;
                this.messages = resp ? resp : [CommonsText.PROBLEMA_DE_CONECTIVIDAD];
                this.toastr.error(this.messages.toString(),
                    CommonsText.ERROR_DE_OPERACION, { timeOut: 5000 });
            });
    }

    getButtonLabel(): string {
        return this.running ? CommonsText.CARGANDO : 'Guardar cambios';
    }
}
